import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/referrals")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Referrals</div>
        <div className="page-subtitle">Manage the referral programme</div>
      </div>
    </>
  ),
});
